import { create } from 'zustand';

import { ReportLinkKey } from '@/shared/model';

import { ReportValidationState, ReportValidationStatus } from './use-report-validation.model';

export const useReportValidationStore = create<ReportValidationState>((set, get) => ({
  batchSetStatuses: (statuses) => {
    set((state) => ({
      links: {
        ...state.links,
        ...statuses,
      },
    }));
  },
  clearAllStatus: () => {
    set({
      links: {} as Record<ReportLinkKey, ReportValidationStatus>,
    });
  },
  defaultQuestionStatus: {},
  getStatus: (link) => get().links[link],
  inCompleteLinks: {} as Record<ReportLinkKey, boolean>,
  links: {} as Record<ReportLinkKey, ReportValidationStatus>,
  setDefaultQuestionStatus: (link: ReportLinkKey, condition: string, validStatus: boolean) => {
    set((state) => ({
      defaultQuestionStatus: {
        ...state.defaultQuestionStatus,
        [link]: {
          ...state.defaultQuestionStatus[link],
          [condition]: validStatus,
        },
      },
    }));
  },
  setInCompleteLink: (link: string, status: boolean) => {
    set((state) => ({
      inCompleteLinks: {
        ...state.inCompleteLinks,
        [link]: status,
      },
    }));
  },
  setStatus: (link: string, status: ReportValidationStatus) => {
    set((state) => ({
      links: {
        ...state.links,
        [link]: status,
      },
    }));
  },
}));
